const environment = process.env.NODE_ENV;
const project = "Home";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  routes: {
    label: "Home",
    prefix: "/corporate",
  },
};

export default config;
